export default "__VITE_ASSET__CbO5$gT$__"